import { Button, Modal } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { ReactComponent as Green_Icon } from '../../../../../../assets/images/svg/Consent_Success_Tick_Icon.svg';
import { ReactComponent as Cross_Icon } from '../../../../../../assets/images/svg/cross-circle.svg';
import Lottie from 'react-lottie';
import loader from '../../../../../../assets/images/lottie-json/lottie_pen_signature.json';

const PatientConsentSuccessModal = ({ showSuccessModal, setShowSuccessModal, setIsSubmitBtnVisible,
  contactNumber, setShowRandomOption }: any): ReactElement => {
  const [counter, setCounter] = useState(0);
  const timerCheck = 3;

  const handleModalCancel = (): any => {
    setShowSuccessModal(false);
    setCounter(0);
    setIsSubmitBtnVisible(true);
    setShowRandomOption(false);
  };

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const getModalClassName = (counterVal: number): string => {
    const baseClass = 'patient-sign-modal custom-modal';
    const variantClass = counterVal !== 0
      ? 'patient-consent-upload-modal-height'
      : 'patient-sign-modal-success';
    return `${baseClass} ${variantClass}`;
  };

  useEffect((): any => {
    let interval: NodeJS.Timeout | null = null;
    if (showSuccessModal) {
      setCounter(timerCheck);
      interval = setInterval((): any => {
        setCounter((prev: number): number => {
          if (prev <= 1) {
            if (interval !== null) {
              clearInterval(interval);
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setCounter(0);
    }

    return (): void => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [showSuccessModal]);

  return (
    <Modal
      visible={showSuccessModal}
      title="Consent Declaration from Patient / Insured"
      onCancel={handleModalCancel}
      className={getModalClassName(counter)}
      footer={null}
      centered={true}
      width={550}
      closeIcon={<Cross_Icon />}
    >
      {counter !== 0 ? (
        <div className="patient-lottie-sign">
          <Lottie options={defaultLottieOptions} />
        </div>
      ) : (
        <div className="text-center patient-sign-mt-20">
          <span className="readonly-inpt"><Green_Icon /></span>
          <p className="consent-success-text">Patient Signature Added Successfully</p>
          <Button type="primary" onClick={handleModalCancel}
            className="margin-top-20 patient-sign-declaration">Go Back to Claim Form</Button>
        </div>
      )}
    </Modal>
  );
};

export default PatientConsentSuccessModal;
